module.exports = __webpack_public_path__ + "img/NewsCenterDetails_pic3.307c9508.png";